import { Checkbox, cn, Label } from "@ronin/ui";
import { type ReactNode, useId } from "react";

/** A titled group in the widget dialog (DESIGN.md: Section label). */
export function FormSection({
  title,
  hint,
  children,
  className,
}: {
  title: string;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("flex min-w-0 flex-col gap-3", className)}>
      <div className="flex flex-col gap-0.5">
        <h3 className="text-xs font-semibold tracking-wide text-dim-foreground uppercase">
          {title}
        </h3>
        {hint && <p className="text-xs text-faint-foreground">{hint}</p>}
      </div>
      {children}
    </section>
  );
}

/** A checkbox with its label (and an optional hint under it), as used in the widget dialog. */
export function CheckField({
  label,
  checked,
  onChange,
  disabled,
  hint,
}: {
  label: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  hint?: ReactNode;
}) {
  const id = useId();
  return (
    <div className="flex flex-wrap items-center gap-x-2">
      <Checkbox
        id={id}
        checked={checked}
        disabled={disabled}
        onCheckedChange={(value) => onChange(value === true)}
      />
      <Label htmlFor={id} className="text-sm text-secondary-foreground">
        {label}
      </Label>
      {hint && <span className="basis-full pl-8 text-xs text-faint-foreground">{hint}</span>}
    </div>
  );
}
